import React from "react";
import { useCountProcessingJobsQuery } from "@/features/processing/processingApi";

/** Shows total Song Processing jobs linked to a Track (active + archived views). */
export function LinkedJobCount({
  trackId,
}: {
  trackId: string;
}): React.ReactElement {
  const active = useCountProcessingJobsQuery({ lineageTrackId: trackId });
  const archived = useCountProcessingJobsQuery({
    lineageTrackId: trackId,
    archived: true,
  });

  const a = active.data?.count;
  const b = archived.data?.count;
  if (
    active.isLoading ||
    archived.isLoading ||
    a == null ||
    b == null ||
    a < 0 ||
    b < 0
  ) {
    return <span>—</span>;
  }
  const total = a + b;
  return (
    <span title={`${a} active · ${b} archived Song Processing jobs`}>{total}</span>
  );
}
